import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import dateSetting from '../../../utils/dateSetting';
import { Form } from 'react-bootstrap';
import ballImage from '../../../assets/img/icon/ball_icon.png';
import PitchZoneChart from '../../../components/chart/PitchZoneChart';
import HitCourseChart from '../../../components/chart/HitCourseChart';
import axios from 'axios';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';

function LocationResultArea({profile, ballCodeArr, leagueType = 4201}) {
    const [cookies] = useCookies(['hiball_token']);
    let [handType, setHandType] = useState('all');
    let [ballCode, setBallCode] = useState('all');
    let [count, setCount] = useState('all');
    let [recordType, setRecordType] = useState('hardHit');
    let dateObj = dateSetting();
    let [loading, setLoading] = useState(false);
    let [recordObj, setRecordObj] = useState({
            week: [],
            ground: [],
            whiff: [],
            select: []
    });

    useEffect(() => {
        setLoading(false);
        let commonParams = {
            recordType: 'futuresRecordService',
            recordName: 'futuresTrackManLogRecord',
            seasons: dateObj['season'],
            leagueTypeCodes: 'KBOFutures',
            pitcherIds: profile['playerId'],
            authToken:JSON.stringify(cookies['hiball_token'])
        }

        if(leagueType == 4201) {
            commonParams['leagueTypeCodes'] = 'KBO';
        } else {
            commonParams['leagueTypeCodes'] = 'KBOFutures';
        }

        if(handType !== 'all') {
            commonParams['battingHands'] = handType;
        }

        if(count !== 'all') {
            commonParams['beforeBallStrikeCnts'] = count;
        } 

        if(ballCode !== 'all') {
            commonParams['ballCodeNames'] = ballCode;
        }

        let weakPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {...commonParams, groupingColumn: 'lowHit'}
        });

        let groundPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {...commonParams, groupingColumn: 'ground'}
        });

        let whiffPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {...commonParams, groupingColumn: 'whiff'}
        });

        let recordTypeParam = {...commonParams};
        
        if(recordType === 'hardHit') {
            recordTypeParam['groupingColumn'] = 'hardHit';
        } else if(recordType === 'hit') {
            recordTypeParam['groupingColumn'] = 'hit';
        } else if(recordType === 'foul') {
            recordTypeParam['groupingColumn'] = 'foul';
        } else if(recordType === 'inplay') {
            recordTypeParam['groupingColumn'] = 'inplay';
        } else { // all
            
        }

        let recordTypePromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: recordTypeParam
        });

        Promise.all([
            weakPromise, groundPromise, whiffPromise, recordTypePromise
        ]).then((response) => {
            setLoading(true);
            setRecordObj((prevState) => {
                return { 
                    ...prevState,
                    week: response[0]['data']['result']['record'],
                    ground: response[1]['data']['result']['record'],
                    whiff: response[2]['data']['result']['record'],
                    select: response[3]['data']['result']['record']
                }
            });
        });
    }, [handType, count, recordType, ballCode]);

    function handTypeHandler(event) {
        let type = event.target.value;
        setHandType(type);
    }

    function countTypeHandler(event) {
        let type = event.target.value;
        setCount(type);
    }

    function dataTypeHander(event) {
        let type = event.target.value;
        setRecordType(type);
    }

    function ballCodeHander(event) {
        let type = event.target.value;
        setBallCode(type);
    }
    
    return (
    <>
    <div className="boxTitle"><img src={ballImage} style={{height:'25px'}} /> 로케이션 & 결과(T)</div>
    <div style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '10px 0px', backgroundColor: '#ddd'}}>
        <div>
            <div>타자유형</div>
            <Form.Group onChange={handTypeHandler}>
                <Form.Select size='sm' defaulevalue={'all'}>
                    <option value={'all'}>전체</option>
                    <option value={'Right'}>우</option>
                    <option value={'Left'}>좌</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div>
            <div>카운트</div>
            <Form.Group onChange={countTypeHandler}>
                <Form.Select size='sm' defaulevalue={'all'}>
                    <option value={'all'}>전체</option>
                    <option value={"0-0"}>초구</option>
                    <option value={"0-1,0-2,1-2,2-2"}>투수카운트</option>
                    <option value={"1-0,2-0,2-1,3-0,3-1"}>타자카운트</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div>
            <div>구종</div>
            <Form.Group onChange={ballCodeHander}>
                <Form.Select size='sm' defaulevalue={'all'}>
                    <option value={'all'}>전체</option>
                    {
                    _.map(ballCodeArr, (ballObj) => (
                        <option key={ballObj['taggedPitchType']} value={ballObj['taggedPitchType']}>{ballObj['ballName']}</option>
                    ))    
                    }
                    
                </Form.Select>
            </Form.Group>
        </div>
    </div>
    {
        loading ?
        <>
        <div style={{display: 'flex', justifyContent: 'space-around', margin: '10px 0px'}}>
            <div style={{border: '1px solid #ccc', padding: '15px 2px'}}>
                <div>약한타구</div>
                <div>
                    <PitchZoneChart width={80} height={80} data={recordObj['week']}/>
                    <HitCourseChart size={80} data={recordObj['week']}/>
                </div>
            </div>
            <div style={{border: '1px solid #ccc', padding: '15px 2px'}}>
                <div>땅볼</div>
                <div>
                    <PitchZoneChart width={80} height={80} data={recordObj['ground']}/>
                    <HitCourseChart size={80} data={recordObj['ground']}/>
                </div>
            </div>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-around', margin: '10px 0px'}}>
            <div style={{border: '1px solid #ccc', padding: '15px 2px'}}>
                <div>헛스윙</div>
                <div>
                    <PitchZoneChart width={80} height={80} data={recordObj['whiff']}/>
                    <HitCourseChart size={80} data={recordObj['whiff']}/>
                </div>
            </div>
            <div style={{border: '1px solid #ccc', padding: '15px 2px'}}>
                <div style={{width: '100px', margin: '0 auto'}}>
                    <Form.Group onChange={dataTypeHander}>
                        <Form.Select size='sm' value={recordType}>
                            <option value={'hardHit'}>강한타구</option>
                            <option value={'hit'}>안타</option>
                            <option value={'foul'}>파울</option>
                            <option value={'inplay'}>인플레이</option>
                            <option value={'all'}>전체</option>
                        </Form.Select>
                    </Form.Group>
                </div>
                <div>
                    <PitchZoneChart width={80} height={80} data={recordObj['select']}/>
                    <HitCourseChart size={80} data={recordObj['select']}/>
                </div>
            </div>
        </div>
        </>
        :
        <DefaultLoader />
    }
    </>
    )
}

export default LocationResultArea;